module.exports = __webpack_public_path__ + "img/upload-icon-claim.9883ce61.svg";